export const fileConstants = {
  GETALL_REQUEST: "FILES_GETALL_REQUEST",
  GETALL_SUCCESS: "FILES_GETALL_SUCCESS",
  GETALL_FAILURE: "FILES_GETALL_FAILURE",

  GET_BY_FILEID_SUCCESS: "FILES_GET_BY_FILEID_SUCCESS",
  GET_ALL_START_FILES_DETAILS_SUCCESS: "GET_ALL_START_FILES_DETAILS_SUCCESS",
  EXPAND_ROW: "FILES_EXPAND_ROW",
  CLEAR_FILES: "CLEAR_FILES",
  FILES_RESET: "FILES_RESET",
  SET_ACTIVE_ROW: "FILES_SET_ACTIVE_ROW",
  TOGGLE_SELECTION: "FILES_TOGGLE_SELECTION",
  TOGGLE_SELECT_ALL: "FILES_TOGGLE_SELECT_ALL",
  TOGGLE_HIDDEN_COLUMNS: "FILES_TOGGLE_HIDDEN_COLUMNS",
  TOGGLE_SHOW_COLUMN_MENU: "FILES_TOGGLE_SHOW_COLUMN_MENU",
  SET_HIDDEN_COLUMNS: "FILES_SET_HIDDEN_COLUMNS",

  TOGGLE_CHANNEL_SELECTION: "FILES_TOGGLE_CHANNEL_SELECTION",
  RESET_CHANNEL_SELECTION: "FILES_RESET_CHANNEL_SELECTION",

  GET_DOWNLOAD_REQUEST: "FILES_GET_DOWNLOAD_REQUEST",
  GET_DOWNLOAD_SUCCESS: "FILES_GET_DOWNLOAD_SUCCESS",

  TOGGLE_DOWNLOAD_SPINNER: "FILES_TOGGLE_DOWNLOAD_SPINNER",
  SET_DOWNLOAD_FILE_PARAMS: "FILES_SET_DOWNLOAD_FILE_PARAMS",
  SET_EMAIL_SENT: "FILES_SET_EMAIL_SENT",
  SET_EMAIL_FAILED_BUT_DOWNLOAD_READY: "FILES_SET_EMAIL_FAILED_BUT_DOWNLOAD_READY"
};
